module.exports = __webpack_public_path__ + "static/media/img_mausoleo.289d4232.jpg";